import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import SearchKeyword from "../components/keyword/SearchKeyword";
import KeywordCategoryMain from "../components/keyword/KeywordCategoryMain";
import ChangeKeywordCategoryModal from "../components/keyword/ChangeKeywordCategoryModal";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import KeywordsForm from "../components/KeywordsForm";
import ImportKeywords from "../components/keyword/ImportKeywords";
import api from '../utils/api';

const AllKeywords = () => {
  const [keywords, setKeywords] = useState([]);
  const [render, setRender] = useState(false);
  const [passSelectedCategoryId, setPassSelectedCategoryId] = useState("all");

  const [selectedKeyword, setSelectedKeyword] = useState(null);
  const [assignCategoryOpen, setAssignCategoryOpen] = useState(false);

  const [bulkAssignOpen, setBulkAssignOpen] = useState(false);
  const [bulkKeywords, setBulkKeywords] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) navigate("/login");
  }, []);

  useEffect(() => {
    api
      .get(`${process.env.REACT_APP_BASE_URL}keyword/all-Keywords`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => setKeywords(res.data.keywords))
      .catch((err) => console.error(err));
  }, [render]);

  const columns = [
    { field: "_id", headerName: "ID", flex: 2 },
    { field: "keyword", headerName: "Keyword", flex: 3 },
  ];

  const flatten = keywords.map((k) => ({
    id: k._id,
    _id: k._id,
    keyword: k.keyword,
  }));

  const handleBulkAssign = (rows) => {
    setBulkKeywords(rows);
    setBulkAssignOpen(true);
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2>Keywords</h2>
      </div>

      <KeywordCategoryMain
        render={render}
        setRender={setRender}
        data={keywords}
        rows={flatten}
        columns={columns}
        setPassSelectedCategoryId={setPassSelectedCategoryId}
        onAssignToKeyword={handleBulkAssign}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: "2rem",
        }}
      >
        <ImportKeywords />
      </div>
      {/* Assign Single */}
      {assignCategoryOpen && (
        <ChangeKeywordCategoryModal
          open={assignCategoryOpen}
          onClose={() => setAssignCategoryOpen(false)}
          keyword={selectedKeyword}
          render={render}
          setRender={setRender}
        />
      )}
    </div>
  );
};

export default AllKeywords;
